<template>
  <div class="vue-modal" id="cc-1919-modal">
    <button class="button--toggle" v-on:click="$emit('toggle-modal')">
      <span class="button--toggle__image">
        <img src="https://cdn.concertconsult.co.uk/1919-survey/arrow_white.svg" alt="arrow">
      </span>
      Last quarter's results
    </button>

    <button class="button--modal-close" v-on:click="$emit('close-modal')">
      <span class='svg-container modal-close'><Close/></span>
      Close
    </button>

    <div class="modal__content-wrapper" id="cc-1919-mdlcntr" v-if="isSubmitted === false">
      <h1 class="headline">Have your say</h1>
      <div class="modal__question">
        <div class="modal__question__text">Q: <div v-html="apiData.question"></div></div>

        <!-- Has question already been answered? -->
        <p v-if="readCookie" class="already-answered-text"><strong>You have already given us an answer to this question.</strong><br>However, you can <span class="link" v-on:click="$emit('toggle-modal')">view last quarter's results.</span></p>

        <!-- Yes / No question type -->
        <div class="modal__question__wrapper" v-if="apiData.type == 'YESNO' && !readCookie">
          <div class="button-container">
            <ButtonAnswerYesNo
              class="modal__question__answer"
              v-for="(answer, index) in apiData.options"
              v-bind:key="answer.id"
              :index="index"
              :text="answer.text"
              :selected="answerSelected"
              :answerId="answer.id"
              v-model="answerSelected"
            />
          </div>
          <!-- <p v-if="answerSelected">Selected value: {{ answerSelected }}</p> -->
          <button class="submit inactive" v-bind:disabled="isButtonDisabled" @click="submitClickHandler">Submit</button> 
        </div>

        <!-- Rating question type -->
        <div class="modal__question__wrapper" v-if="apiData.type == 'RATING' && !readCookie">
          <star-rating
            v-model="answerSelected"
            :apiData="apiData"
          ></star-rating>
          <!-- <p v-if="answerSelected">Selected value: {{ answerSelected }}</p> -->
          <button class="submit" v-bind:disabled="isButtonDisabled" @click="submitClickHandler">Submit</button>
        </div>

        <!-- Radio question type -->
        <div class="modal__question__wrapper" v-if="apiData.type == 'RADIO' && !readCookie">
          <RadioForm
            :questionOptions="apiData.options"
            @answerSelected="updateAnswerSelected"
          ></RadioForm>
          <!-- <p v-if="answerSelected">Selected value: {{ answerSelected }}</p> -->
          <button class="submit" v-bind:disabled="isButtonDisabled" @click="submitClickHandler">Submit</button>
        </div>

      </div>
      <p>If you would like to share any further comments about the website, please contact <a href="mailto:iphpplan@zedra.com" class="cc-1919-link link">iphpplan@zedra.com</a></p>
      <p>We really welcome your feedback, so each quarter we post a different question about the Plan and our communications with you.</p>
      <p>Please submit your feedback and next quarter, you’ll be able to click the top right button to view the results.</p>
    </div>

    <div class="modal__content-wrapper" id="cc-1919-mdlcntr" v-if="isSubmitted === true">
      <div class="modal__question">
        <h1 class="headline">Thank you</h1>
        <em class="modal__question__text">Your answer has been submitted</em>
        <p>Please check back next quarter when we’ll post the results of this survey and invite you to answer another question. </p>
        <p>We appreciate your feedback.</p>
      </div>
    </div>

  </div>

</template>

<script>

import ButtonAnswerYesNo from './ButtonAnswerYesNo.vue' 
import StarRating from './StarRating.vue' 
import VueCookies from 'vue-cookies'
import RadioForm from './radio/RadioForm.vue'

import Close from '../assets/close.svg'

// import StarRating from 'vue-star-rating'

export default {
  name: 'QuestionModalCurrent',
  components: {
    ButtonAnswerYesNo,
    StarRating,
    RadioForm,
    Close
  },
  props: {
    apiData: Object
  },
  computed: {
    isButtonDisabled () {
      if ( this.answerSelected != null) {
        return false;
      } else {
        return true;
      }
    },
    readCookie () {
      if ( $cookies.get('question-answered') == this.apiData.id ) {
        return true; //set true for production
      } else {
        return false
      }
    },
  },
  methods: {
    sendSubmission () {
      console.log('sendSubmission');
      this.isSubmitted = true;
      axios.post('https://api2.survey.concertstaging.co.uk/api/answer/' + this.apiData.id, {answer: this.answerSelected} );
      console.log('https://api2.survey.concertstaging.co.uk/api/answer/' + this.apiData.id, {answer: this.answerSelected} );
    },
    setCookie () {
      console.log('setCookie');
      $cookies.set("question-answered", this.apiData.id, "2m");
    },
    submitClickHandler () {
      console.log('clickHandler');
      this.sendSubmission ();
      this.setCookie ();
    },
    updateAnswerSelected (answer) {
      this.answerSelected = answer;
    },
  },
  mounted: function () {
    let content = document.getElementById('cc-1919-mdlcntr');
    let modal = document.getElementById('cc-1919-modal');
    if ( content.clientHeight > modal.clientHeight ) {
      modal.style.height = content.clientHeight + "px";
    }
  },
  data: function () {
    return {

      isSubmitted: false,
      answerSelected: null,

    }
  }
}
</script>